import React from 'react';
import { Icon } from '@iconify/react';
import { Smile, CalendarDays } from 'lucide-react';

const GreetingCard = () => {
  const today = new Date().toLocaleDateString();

  return (
    <div className="bg-gradient-to-r from-blue-100 to-blue-50 rounded-2xl shadow-lg p-6 flex flex-col sm:flex-row justify-between items-center space-y-4 sm:space-y-0">
      
      {/* Icon + Greeting + Date */}
      <div className="flex items-center space-x-4">
        <div className="bg-white p-3 rounded-full shadow-md">
          <Smile className="text-blue-600 w-8 h-8" />
        </div>
        <div className="text-center sm:text-left">
          <h2 className="text-xl font-bold text-gray-800 flex items-center justify-center sm:justify-start gap-2">
            Welcome back <Icon icon="fluent-emoji:waving-hand" className="h-6 w-6" aria-hidden="true" />
          </h2>
          <p className="text-sm text-gray-600">Hope you're having a productive day at MyODS!</p>
          <p className="text-sm text-gray-600">Enjoy a 30 day snapshot of your activity!</p>
          <div className="mt-1 flex items-center justify-center sm:justify-start text-sm text-gray-700 gap-1">
            <CalendarDays className="w-4 h-4 text-gray-500" />
            <span className="font-medium">{today}</span>
          </div>
        </div>
      </div>

    </div>
  );
};

export default GreetingCard;
